const PowerType = {
    MANUAL: "MANUAL",
    ELECTRIC: "ELECTRIC",
    FUEL: "FUEL"
}

export default PowerType;